export enum ContractStatus {
  Done = 'Terminé',
  Invalidated = 'Invalidé',
  ValidationCLI = 'En validation Métropole',
  ValidatedCLI = 'Validé',
}

export const labelsByContractStatus: string[] = [
  ContractStatus.Done,
  ContractStatus.Invalidated,
  ContractStatus.ValidationCLI,
  ContractStatus.ValidatedCLI,
];
